// Scope for the demo fixtures in this folder.
//
// Everything under _mock/ is DEMO content authored for the **Life Connect**
// office. Any other office (HLC, and every real office) must read real data and
// show honest empty states rather than borrowing Life Connect's fixtures — a
// mission with no stories should look empty, not like someone else's demo.
//
// Gate every mock accessor on these helpers.

export const LC_OFFICE_ID = 'lc-office-lifeconnect';

/** True only for mission ids belonging to the Life Connect demo. */
export function isDemoMissionId(missionId) {
  return String(missionId ?? '').startsWith('lc-');
}

/** True only for missions of the Life Connect demo office. */
export function isDemoMission(mission) {
  if (!mission) return false;
  return mission.office_id === LC_OFFICE_ID || isDemoMissionId(mission.id);
}

/** True only for the Life Connect demo office. */
export function isDemoOffice(officeId) {
  return officeId === LC_OFFICE_ID;
}

// The Storybook / dev-preview harness office (no server behind it) — it keeps
// the rich fixtures so the stories render.
export const PREVIEW_OFFICE_ID = 'preview-office';

/**
 * May an EMPTY real feed fall back to the demo fixtures for this office?
 * Only the Life Connect demo and the preview harness — live e2e 2026-10-07
 * F-L7 : a brand-new real project's Stories tab showed LC-5… demo stories.
 */
export function allowsMockFallback(officeId) {
  return isDemoOffice(officeId) || officeId === PREVIEW_OFFICE_ID;
}
